"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CLEAR_REGION_TIMEOUT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AnnouncerContext = _interopRequireDefault(require("./AnnouncerContext"));
var _interfaces = require("./interfaces");
var _core = require("@emotion/core");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ANNOUNCE_TIMEOUT = 1000;
var CLEAR_REGION_TIMEOUT = 2000;
exports.CLEAR_REGION_TIMEOUT = CLEAR_REGION_TIMEOUT;
var LiveRegion = function LiveRegion(_ref) {
  var ariaLive = _ref['aria-live'],
    role = _ref.role,
    children = _ref.children;
  var _useContext = (0, _react.useContext)(_AnnouncerContext.default),
    announceAssertive = _useContext.announceAssertive,
    announcePolite = _useContext.announcePolite;
  var timerId = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var functionsMap = {
      polite: announcePolite,
      assertive: announceAssertive
    };
    var announceFn = functionsMap[ariaLive];
    if (announceFn) {
      if (timerId.current) {
        window.clearTimeout(timerId.current);
      }
      timerId.current = window.setTimeout(function () {
        announceFn({
          region: children,
          role: role
        });
        timerId.current = window.setTimeout(function () {
          announceFn({
            region: '',
            role: role
          });
        }, CLEAR_REGION_TIMEOUT);
      }, ANNOUNCE_TIMEOUT);
    } // Specify how to clean up aria regions.

    return function cleanup() {
      if (timerId.current) {
        window.clearTimeout(timerId.current);
      }
      Object.values(_interfaces.LiveRegionRole).map(function (role) {
        announcePolite({
          region: '',
          role: role
        });
        announceAssertive({
          region: '',
          role: role
        });
        return null;
      });
    };
  }, [children, announceAssertive, announcePolite, ariaLive, role]);
  return (0, _core.jsx)(_react.default.Fragment, null, children);
};
var _default = LiveRegion;
exports.default = _default;